export const DEVICE_INFO_UPDATE = 'DEVICE_INFO_UPDATE';
